import { User } from '@core/auth/hooks/use-profile/use-profile.hook.types'

import { getUserPermission } from '../get-user-permission/get-user-permission'
import { SUPERVISOR_PERMISSIONS } from '../user-permissions/user-permissions.types'

export const hasSupervisorPermission = (user?: User) => {
  if (!user) return false

  const userPermission = getUserPermission(user)

  if (!userPermission) return false
  return SUPERVISOR_PERMISSIONS.includes(userPermission)
}
